import React from 'react';

import { Form, Input } from 'antd';
import { Row } from 'farmhub-ui-core';

import { TagOption } from 'components';
import { theme } from 'styled';
import { SIZE } from 'utils';

import SelectColor from '../SelectColor';
import { CInput } from './styles';

interface UpdateOptionInputProps {
  isEditing: boolean;
  onSubmit?: (e: any) => void;
  option: any;
  onClick?: () => void;
  handleResetCurrentOption?: () => void;
}

const UpdateOptionInput = ({
  isEditing,
  onSubmit,
  option,
  onClick,
  handleResetCurrentOption,
}: UpdateOptionInputProps): JSX.Element => {
  const inputRef = React.useRef<any>(null);
  const [color, setColor] = React.useState(option.color);
  const [content, setContent] = React.useState('');
  const [form] = Form.useForm();

  React.useEffect(() => {
    setContent(option.content);
    form.setFieldsValue({
      optionLabel: option.content,
    });
  }, [option]);

  const handleSubmit = (e: any): void => {
    if (option.content != e.target.value || color?.id != option?.color?.id) {
      form.validateFields().then(async () => {
        if (e.target.value.trim()) {
          const body = {
            colorID: color.id,
            content: e.target.value,
          };

          onSubmit && onSubmit(body);
        }
      });
    } else {
      handleResetCurrentOption && handleResetCurrentOption();
    }
  };

  const handleSelectColor = (color: any) => {
    setColor(color);
    inputRef.current.focus();
  };

  const handleClick = async (): Promise<void> => {
    onClick && (await onClick());
    inputRef.current?.focus();
  };

  return isEditing ? (
    <Form form={form} layout="vertical">
      <Form.Item
        name="optionLabel"
        rules={[
          {
            required: true,
            message: 'Bạn chưa nhập tên nhãn!',
          },
        ]}
      >
        <CInput
          ref={inputRef}
          defaultValue={option.content}
          height={theme.input.height.md}
          maxLength={50}
          placeholder="Nhập tên nhãn"
          suffix={<SelectColor color={color} setColor={handleSelectColor} />}
          value={content}
          onChange={e => e.target.value.trim() && setContent(e.target.value)}
          onPressEnter={handleSubmit}
        />
      </Form.Item>
    </Form>
  ) : (
    <Row height="36px" styles={{ marginBottom: '12px' }}>
      <TagOption
        notShowPointer
        color={option?.color?.code}
        fontSize={13}
        label={option.content}
        padding="6px 12px"
        size={SIZE.LARGE}
        styles={{
          width: '100%',
          height: '100% !important',
        }}
        onClick={handleClick}
      />
    </Row>
  );
};

export default UpdateOptionInput;
